import { useEffect } from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useGlobalAppState } from '../GlobalAppState/GlobalAppState';

// ─────────────────────────────────────────────────────────────────────────────

export const useInitializeDietaryPreferences = () => {
  const isAllergensEnabled = useFeatureFlag('CELS-5135-allergen-compliance-enabled');
  const { dietaryRestrictionsMachineRef: actor } = useGlobalAppState();

  useEffect(() => {
    actor.send({ type: 'INITIALIZE', isAllergensEnabled });
  }, [actor, isAllergensEnabled]);
};
